import { Outlet } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { HeadScriptInjector } from "./HeadScriptInjector";
import { Menu } from "lucide-react";

export function AppLayout() {
  return (
    <>
      <HeadScriptInjector />
      <SidebarProvider>
        <div className="min-h-screen flex w-full bg-background">
          <AppSidebar />
          <div className="flex-1 flex flex-col">
            {/* Header móvel com trigger sempre visível */}
            <header className="sticky top-0 z-10 flex h-14 items-center gap-4 border-b bg-background px-4 lg:hidden">
              <SidebarTrigger className="h-8 w-8">
                <Menu className="h-5 w-5" />
              </SidebarTrigger>
              <div className="flex items-center gap-2">
                <span className="text-lg font-display text-primary">Dashi</span>
                <span className="text-xs text-muted-foreground">Dashboard SaaS</span>
              </div>
            </header>
            
            <main className="flex-1">
              <Outlet />
            </main>
          </div>
        </div>
      </SidebarProvider>
    </>
  );
}
